import React, { useState, useEffect } from "react";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Stack,
} from "@vapor/react-material";
import Paper from "@vapor/react-material/Paper";
import { useRequest } from "@onefront/react-sdk";
import InvoicesProducts from "./InvoicesProducts.tsx";
import { ItemProps } from "../types.ts";
import { AngleLeft, AngleRight } from "@vapor/react-icons";
import { Typography } from "@vapor/react-material";
import { IconButton } from "@vapor/react-material";

export const LeadManagement = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 5;
  const [totalCount, setTotalCount] = useState(0);
  const [itemsToDisplay, setItemsToDisplay] = useState([]);

  const headCells = [
    { id: "invoice", numeric: false, disablePadding: true, label: "Invoice" },
    { id: "date", numeric: true, disablePadding: false, label: "Date" },
    {
      id: "customer",
      numeric: false,
      disablePadding: false,
      label: "Customer",
    },
    {
      id: "totalAmount",
      numeric: true,
      disablePadding: false,
      label: "Total Amount",
    },
    { id: "actions", numeric: false, disablePadding: false, label: "" },
  ];

  const { loading, error, fetch } = useRequest();

  useEffect(() => {
    getInvoices();
  }, [currentPage]); 

  const getInvoices = async () => {
    try {
      const res = await fetch({
        method: "get",
        url: `https://construction-next-test.service.ts-paas.com/api/Invoices?PageNumber=${currentPage}&PageSize=${pageSize}`,
      });
  
      if (res.headers && res.headers["x-pagination"]) {
        const xHeader = res.headers["x-pagination"];
        const xPaginationData = JSON.parse(xHeader);
        const totalCount = xPaginationData.TotalCount;
        setTotalCount(totalCount);
  
        const receivedItems = res.data; 
        setItemsToDisplay(receivedItems); 
      }
    } catch (error) {

    }
  };

  

  const handleNextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  if (loading) {
    return (<div>Data is loading ...</div>)
  }
  return (
    <Stack>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700, width: "99%" }} aria-label="customized table">
          <TableHead shadow>
            <TableRow>
              <TableCell />
              {headCells.map((headCell) => (
                <TableCell
                  align={headCell.id === "invoice" ? "left" : "right"}
                  key={headCell.id}
                  padding={headCell.disablePadding ? "none" : "normal"}
                >
                  <ExtendedTypography variant="boldLabel">
                    {headCell.label}
                  </ExtendedTypography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {itemsToDisplay.map((item: ItemProps, index) => (
              <InvoicesProducts key={index} row={item} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Stack
        ml="87%"
        mt="3%"
        direction="row"
        spacing={1}
        display="flex"
        alignItems="center"
      >
        <Typography color="secondary">{`${
          (currentPage - 1) * pageSize + 1
        }-${Math.min(currentPage * pageSize, totalCount)} `}</Typography>
        <Typography color="grey">{`of ${totalCount}`}</Typography>
        <IconButton onClick={handlePrevPage} disabled={currentPage === 1}>
          <AngleLeft color="primary" />
        </IconButton>
        <IconButton
          onClick={handleNextPage}
          disabled={currentPage === Math.ceil(totalCount / pageSize)}
        >
          <AngleRight color="primary" />
        </IconButton>
      </Stack>
    </Stack>
  );
};
